import React, { useEffect, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { enableDodAtom } from '../../atoms';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { formatMetricDataForChart } from './utils/utils';
import { TrendContainer } from './styled';

export interface TrendProps {
  data: any[];
  metricKey: string;
  style?: React.CSSProperties;
  dodData?: any[];
}

const Trend = ({ data = [], metricKey, style, dodData = [] }: TrendProps) => {
  const { instance, chartInstanceRefCb } = useChartInstance({});
  const dodEnabled = useAtomValue(enableDodAtom);

  // Base chart option without DoD
  const baseChartOption = useMemo(
    () =>
      formatMetricDataForChart({
        chartData: data,
        metricKey,
      }),
    [data, metricKey],
  );

  // Set base option first
  useEffect(() => {
    if (instance && baseChartOption) {
      instance.setOption(baseChartOption);
    }
  }, [instance, baseChartOption]);

  useEffect(() => {
    if (instance) {
      const option = instance.getOption() as any;
      if (option && option._viewType === 'timeseries') {
        if (dodEnabled && dodData.length > 0) {
          const updatedOption = formatMetricDataForChart({
            chartData: data,
            metricKey,
            dodData,
          });
          instance.setOption(updatedOption, { notMerge: true });
        } else {
          instance.setOption(baseChartOption, { notMerge: true });
        }
      }
    }
  }, [instance, dodEnabled, dodData, data, metricKey, baseChartOption]);

  return (
    <TrendContainer style={style}>
      <BaseChart
        chartId={`widget-flow-trend-${metricKey}`}
        chartInstanceRefCb={chartInstanceRefCb}
        style={{ height: '50px', width: '100%' }}
      />
    </TrendContainer>
  );
};

export default React.memo(Trend);
